import { defineTokens } from "@chakra-ui/react";

export const sizes = defineTokens.sizes({
  "1": {
    value: "0.2rem",
  },
  "2": {
    value: "0.4rem",
  },
  "3": {
    value: "0.6rem",
  },
  "4": {
    value: "0.8rem",
  },
  "5": {
    value: "1rem",
  },
  "6": {
    value: "1.2em",
  },
  "7": {
    value: "1.4rem",
  },
  "8": {
    value: "1.6rem",
  },
  "9": {
    value: "1.8rem",
  },
  "10": {
    value: "2rem",
  },
  "11": {
    value: "2.2rem",
  },
  "12": {
    value: "2.4rem",
  },
  "14": {
    value: "2.8rem",
  },
  "16": {
    value: "3.2rem",
  },
  "20": {
    value: "4rem",
  },
  "24": {
    value: "4.8rem",
  },
  "28": {
    value: "5.6rem",
  },
  "32": {
    value: "6.4rem",
  },
  "36": {
    value: "7.2rem",
  },
  "40": {
    value: "8rem",
  },
  "44": {
    value: "8.8rem",
  },
  "48": {
    value: "9.6rem",
  },
  "52": {
    value: "10.4rem",
  },
  "56": {
    value: "11.2rem",
  },
  "60": {
    value: "12rem",
  },
  "64": {
    value: "12.8rem",
  },
  "72": {
    value: "14.4rem",
  },
  "80": {
    value: "16rem",
  },
  "96": {
    value: "20rem",
  },
  "3xs": {
    value: "14rem",
  },
  "2xs": {
    value: "16rem",
  },
  xs: {
    value: "20rem",
  },
  sm: {
    value: "24rem",
  },
  md: {
    value: "28rem",
  },
  lg: {
    value: "32rem",
  },
  xl: {
    value: "36rem",
  },
  "2xl": {
    value: "42rem",
  },
  "3xl": {
    value: "48rem",
  },
  "4xl": {
    value: "56rem",
  },
  "5xl": {
    value: "64rem",
  },
  "6xl": {
    value: "72rem",
  },
  "7xl": {
    value: "80rem",
  },
  "8xl": {
    value: "90rem",
  },
  "0.5": {
    value: "0.125rem",
  },
  "1.5": {
    value: "0.375rem",
  },
  "2.5": {
    value: "0.625rem",
  },
  "3.5": {
    value: "0.875rem",
  },
  "4.5": {
    value: "1.125rem",
  },
  "1/2": {
    value: "50%",
  },
  "1/3": {
    value: "33.333333%",
  },
  "2/3": {
    value: "66.666667%",
  },
  "1/4": {
    value: "25%",
  },
  "3/4": {
    value: "75%",
  },
  "1/5": {
    value: "20%",
  },
  "2/5": {
    value: "40%",
  },
  "3/5": {
    value: "60%",
  },
  "4/5": {
    value: "80%",
  },
  "1/6": {
    value: "16.666667%",
  },
  "2/6": {
    value: "33.333333%",
  },
  "3/6": {
    value: "50%",
  },
  "4/6": {
    value: "66.666667%",
  },
  "5/6": {
    value: "83.333333%",
  },
  "1/12": {
    value: "8.333333%",
  },
  "2/12": {
    value: "16.666667%",
  },
  "3/12": {
    value: "25%",
  },
  "4/12": {
    value: "33.333333%",
  },
  "5/12": {
    value: "41.666667%",
  },
  "6/12": {
    value: "50%",
  },
  "7/12": {
    value: "58.333333%",
  },
  "8/12": {
    value: "66.666667%",
  },
  "9/12": {
    value: "75%",
  },
  "10/12": {
    value: "83.333333%",
  },
  "11/12": {
    value: "91.666667%",
  },
  max: {
    value: "max-content",
  },
  min: {
    value: "min-content",
  },
  fit: {
    value: "fit-content",
  },
  prose: {
    value: "60ch",
  },
  full: {
    value: "100%",
  },
  dvh: {
    value: "100dvh",
  },
  svh: {
    value: "100svh",
  },
  lvh: {
    value: "100lvh",
  },
  dvw: {
    value: "100dvw",
  },
  svw: {
    value: "100svw",
  },
  lvw: {
    value: "100lvw",
  },
  vw: {
    value: "100vw",
  },
  vh: {
    value: "100vh",
  },
});
